/** Email links select a challenge; only the separately entered code authorizes access. */
export function readRecruitVerificationLink(hash = window.location.hash) {
  if (hash.length > 180) {
return null;
}
  const params = new URLSearchParams(hash.slice(1));
  const challenge = params.get('recruit_challenge') ?? '';
  const nmls = params.get('nmls') ?? '';
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(challenge)
    || !/^\d{6,10}$/.test(nmls)) {
return null;
}
  return { challenge, nmls };
}
